import styled from "styled-components";

export const AnimationDisablerDiv = styled("div").withConfig({
   shouldForwardProp: p => !["enableAnimation"].includes(p)
})<{ enableAnimation?: boolean }>`
   ${({ enableAnimation }) => (enableAnimation ? "" : "& * {animation: unset !important;}")}
`;
